// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-textarea[data-v-54e29ffb] textarea {\r\n  line-height: 1.2;\r\n  font-size: smaller;\r\n  font-weight: bold;\n}\r\n/*.row {\r\n  border: solid 1px orange;\r\n}\r\n.col {\r\n  border: solid 1px red;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
